import React from "react";
import {
  Box,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Heading,
  Flex,
  Icon,
  Text,
} from "@chakra-ui/react";
import { FaFileAlt, FaExchangeAlt, FaUniversity, FaCode } from "react-icons/fa";
import DocumentUploadTab from "App/BsesPoc/components/foreignProcess/DocumentUploadTab";
import ForeignEstimate from "App/BsesPoc/components/ForeignEstimate/ForeignEstimate";
import ForeignBank from "App/BsesPoc/components/Master/ForeignBank/ForeignBank";
import SapXmlPayload from "App/BsesPoc/components/SapXmlPayload/SapXmlPayload";

const ForeignAdminTools = () => {
  return (
    <Box p={1} bg="gray.50" minH="100vh">
      <Box
        bg="white"
        borderRadius="xl"
        shadow="sm"
        border="1px"
        borderColor="gray.200"
        overflow="hidden"
      >
        {/* Header Section */}
        <Box p={4} borderBottom="1px" borderColor="gray.100" bg="white">
          <Flex align="center" gap={3}>
            <Box
              p={2}
              bg="teal.50"
              borderRadius="lg"
            >
              <Icon as={FaUniversity} color="teal.500" boxSize={5} />
            </Box>
            <Box>
              <Heading size="md" color="gray.800" fontWeight="700">Foreign Admin Tools</Heading>
              <Text fontSize="xs" color="gray.500">Manage uploads, rates, and bank masters for foreign workflows.</Text>
            </Box>
          </Flex>
        </Box>

        {/* Tabbed Content Section */}
        <Tabs variant="unstyled" colorScheme="teal" isLazy>
          <TabList
            bg="gray.50"
            px={2}
            py={2}
            borderBottom="1px"
            borderColor="gray.200"
            gap={2}
          >
            <CustomTab icon={FaFileAlt} label="Document Upload" />
            <CustomTab icon={FaExchangeAlt} label="Exchange Rate" />
            <CustomTab icon={FaUniversity} label="Bank Master" />
            <CustomTab icon={FaCode} label="SAP XML Payload" />
          </TabList>

          <TabPanels>
            <TabPanel p={0} bg="white">
              <Box animation="fadeIn 0.4s ease-in-out">
                <DocumentUploadTab />
              </Box>
            </TabPanel>
            <TabPanel p={0} bg="white">
              <Box animation="fadeIn 0.4s ease-in-out">
                <ForeignEstimate />
              </Box>
            </TabPanel>
            <TabPanel p={0} bg="white">
              <Box animation="fadeIn 0.4s ease-in-out">
                <ForeignBank />
              </Box>
            </TabPanel>
            <TabPanel p={0} bg="white">
              <Box animation="fadeIn 0.4s ease-in-out">
                <SapXmlPayload />
              </Box>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>

      {/* Inline styles for basic animations */}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </Box>
  );
};

// Custom tab component for consistent premium look
const CustomTab = ({ icon, label }: { icon: any; label: string }) => (
  <Tab
    _selected={{
      color: "white",
      bg: "teal.500",
      shadow: "md"
    }}
    _hover={{
      bg: "gray.100",
      transform: "translateY(-1px)"
    }}
    borderRadius="lg"
    px={4}
    py={2}
    fontSize="sm"
    fontWeight="600"
    color="gray.600"
    transition="all 0.2s cubic-bezier(.08,.52,.52,1)"
  >
    <Flex align="center" gap={2}>
      <Icon as={icon} boxSize={4} />
      <Text>{label}</Text>
    </Flex>
  </Tab>
);

export default ForeignAdminTools;


